var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.fullscreenLoading),expression:"fullscreenLoading"}],attrs:{"element-loading-text":"正在绑定授权信息"}})
}
var staticRenderFns = []

export { render, staticRenderFns }